import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { MonicaObject } from '.';

/**
 * フリー テキスト アイテム モニカ オブジェクト クラス
 */
export default class FreeText extends MonicaObject {
  textView:SVGElement;

  // 表示非表示
  _visible: boolean;

  set visible(booValue: boolean) {
    this._visible = booValue;
    this.viewObj.style.visibility = booValue ? 'visible' : 'hidden';
  }

  get visible() { return this._visible; }

  // eslint-disable-next-line no-useless-constructor
  constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    super(_itemInfo);
  }

  /**
   * リドロー
   */
  reCreateImage = (): void => {
    // 再作成
    this.textView.remove();
    this.createImage();
  }

  /**
   * ビューの作成
   */
  createImage() {
    const textString = this.itemInfo.text;
    const fontSize = this.itemInfo.font_size;
    let textX = 0;
    let textY = 0;
    let textArray: string[] = [];
    let viewObj: Element;
    // テキスト項目に複数行があることを確認してください
    if (textString.indexOf('\n') !== -1) {
      textArray = textString.split('\n');
    } else {
      textArray[0] = textString;
    }
    if (this.spt === undefined) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
    } else {
      viewObj = this.spt.element;
    }
    this.textView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.textView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_textGroup`);
    // テキストサイズを取得
    const textSize = marietta.webcad.util.TextUtil.getTextSizeWh(textString, marietta.webcad.WebCADGlobal.freeTextFontFamily, fontSize);
    this.itemInfo.width = textSize.width;
    this.itemInfo.height = textSize.height;
    // テキストアイテムの複数行処理
    // 複数のテキスト用に個別のテキスト svg を作成する
    for (let i = 0; i < textArray.length; i += 1) {
      textX = 0;
      const textWidth = textSize.widthList[i];
      if (i > 0) {
        textY += fontSize;
      }
      // svgの作成
      const textObj = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      textObj.setAttribute('x', String(textX));
      textObj.setAttribute('y', String(textY));
      textObj.setAttribute('font-size', String(fontSize));
      textObj.setAttribute('fill', this.itemInfo.text_color);
      textObj.setAttribute('font-family', marietta.webcad.WebCADGlobal.freeTextFontFamily);
      textObj.setAttribute('transform', `translate(${textX - textWidth / 2}, ${textY - ((fontSize * i) + ((fontSize * textArray.length) / 2)) + (fontSize / 1.1)})`);
      if (this.itemInfo.is_italic) {
        textObj.setAttribute('font-style', 'italic');
      }
      if (this.itemInfo.is_bold) {
        textObj.setAttribute('font-weight', 'bold');
      }
      if (this.itemInfo.is_underline) {
        textObj.setAttribute('text-decoration', 'underline');
      }
      if (this.itemInfo.is_strike_through) {
        textObj.setAttribute('text-decoration', 'line-through');
      }
      if (this.itemInfo.text_alignment === 'left') {
        textX = textWidth / 2 - textSize.width / 2;
        textObj.setAttribute('x', String(textX));
      } else if (this.itemInfo.text_alignment === 'right') {
        textX = textSize.width / 2 - textWidth / 2;
        textObj.setAttribute('x', String(textX));
      }
      textObj.textContent = textArray[i];
      textObj.setAttribute('class', 'freeText_text');
      this.textView.appendChild(textObj);
    }
    viewObj.appendChild(this.textView);
    if (this.spt === undefined) {
      this.spt = new SVGSprite(viewObj);
    }
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    this.spt.update();
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    if (Number.isNaN(this.spt.scaleX)) this.spt.scaleX = 1;
    if (Number.isNaN(this.spt.scaleY)) this.spt.scaleY = 1;
    this.spt.rotation = this.itemInfo.rotation;
    this.spt.update();
  }

  /**
   * テキストアイテム itemInfoCollection データの更新
   */
  updateTextAttributes() {
    this.itemInfo.text_color = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_color;
    this.itemInfo.font_size = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size;
    this.itemInfo.is_bold = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold;
    this.itemInfo.is_italic = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_italic;
    this.itemInfo.is_underline = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_underline;
    this.itemInfo.is_strike_through = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_strike_through;
    this.itemInfo.text_alignment = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_alignment;
    this.itemInfo.rotation = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.rotation;
  }

  /**
   * 表示ON
   */
  show() {
    // 表示の再設定
    this.visible = true;
  }

  /**
   * 表示ON
  */
  hide() {
    this.visible = false;
  }
}
